import {Button, Form, Checkbox, Select, Input, ColorPicker, Modal, Card} from "antd";
import React, {useEffect, useRef, useState} from 'react';
import {DndTable, DragHandle} from "./DndTable";
import {DeleteOutlined, HolderOutlined, MenuOutlined} from "@ant-design/icons";
import { useInfoUser } from "../../store/UserStore";
import {DndContext} from "@dnd-kit/core";
import {restrictToVerticalAxis} from "@dnd-kit/modifiers";
import {arrayMove, verticalListSortingStrategy} from "@dnd-kit/sortable";
import {SortableContext} from '@dnd-kit/sortable';
import {SortableCard} from "./SortableCard";
import MobileWorkflowView from "./MobileWorkflowView";

const {Option} = Select;

const ModalWorKFlowIME = ({isWorkFlowIME, editingKey, handleModalCancel, updateWorkFlowItem}) =>{
  const [inputValues, setInputValues] = useState({
    krName: '',
    enName: '',
    vnName: ''
  });
  const {user, languageMap } = useInfoUser();

  const krName = useRef(null);
  const enName = useRef(null);
  const vnName = useRef(null);

  const handleInputChange = (e, field) => {
    setInputValues({
      ...inputValues,
      [field]: e.target.value
    });
  };

  const handleOk = () => {
    updateWorkFlowItem(inputValues);
    handleModalCancel();
  };

  return (
    <Modal
      title={languageMap?.["project.workflow.modal.title"] ?? "IME"}
      visible={isWorkFlowIME}
      onCancel={handleModalCancel}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={handleModalCancel}>{languageMap?.["project.workflow.modal.cancelBtn"] ?? "Cancel"}</Button>,
        <Button key="ok" type="primary" onClick={handleOk} disabled={
          !krName?.current?.input?.value ||
          !enName?.current?.input?.value ||
          !vnName?.current?.input?.value
        }>OK</Button>,
      ]}
    >
      <div className="py-2">
        <Form.Item label={languageMap?.["project.workflow.modal.contentKr"] ?? "KR:"} name={['progressRequests', editingKey, 'krName']} rules={[
          {
            required: true,
            message: languageMap?.["project.management.require.krnameWorkflow"] ?? 'krName is require!',
          },
          {
            max: 100,
            message: 'krName cannot exceed 100 characters!',
          },
        ]}>
          <Input
            ref={krName}
            maxLength={100}
            placeholder="IME1"
            value={inputValues.krName}
            onChange={(e) => handleInputChange(e, 'krName')}
          />
        </Form.Item>
        <Form.Item label={languageMap?.["project.workflow.modal.contentEn"] ?? "EN:"} name={['progressRequests', editingKey, 'enName']} rules={[
          {
            required: true,
            message: languageMap?.["project.management.require.ennameWorkflow"] ?? 'enName is require!',
          },
          {
            max: 100,
            message: 'enName cannot exceed 100 characters!',
          },
        ]}>
          <Input
            ref={enName}
            maxLength={100}
            placeholder="IME2"
            value={inputValues.enName}
            onChange={(e) => handleInputChange(e, 'enName')}
          />
        </Form.Item>
        <Form.Item label={languageMap?.["project.workflow.modal.contentVn"] ?? "VN:"} name={['progressRequests', editingKey, 'vnName']} rules={[
          {
            required: true,
            message: languageMap?.["project.management.require.vnnameWorkflow"] ??'vnName is require!',
          },
          {
            max: 100,
            message: 'vnName cannot exceed 100 characters!',
          },
        ]}>
          <Input
            ref={vnName}
            maxLength={100}
            placeholder="IME3"
            value={inputValues.vnName}
            onChange={(e) => handleInputChange(e, 'vnName')}
          />
        </Form.Item>
      </div>
    </Modal>
  );
};

const WorkFlow = ({initialValues, stageWorkFlowOption, form, permissionCurrentUser, different, isMobile}) => {
  const [workFlow, setWorkFlow] = useState([{
    key: 0,
    segmentCode: null,
    krName: null,
    enName: null,
    vnName: null,
    color: null,
    sortSequence: 1
  }]);
  const { user, languageMap } = useInfoUser();
  const [isWorkFlowIME, setIsWorkFlowIME] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [count, setCount] = useState(1);

  const columns = [
    {
      key: 'sort',
      align: 'center',
      width: 40,
      fixed: true,
      render: (_, record) => (
        <>
          <Form.Item name={['progressRequests', record.key, 'projectProgressCode']}
                     initialValue={record?.projectProgressCode} noStyle/>
          <Form.Item
            name={['progressRequests', record.key, 'sortSequence']}
            initialValue={workFlow.find(item => item.key === record.key)?.sortSequence}
            noStyle
          >
            <DragHandle/>
          </Form.Item>
        </>
      ),
    },
    {
      title: languageMap?.["project.management.workFlow.stage"] ?? 'Stage',
      dataIndex: 'stage',
      render: (_, record) => (
          <Form.Item name={['progressRequests', record.key, 'segmentCode']} rules={[
            {
              required: true,
              message: languageMap?.["project.management.require.stageWorklflow"] ?? 'Stage is require!',
            },
          ]} className="p-0 m-0">
            <Select disabled={different.type === "UPDATED" && !permissionCurrentUser?.includes("U")} placeholder={languageMap?.["project.management.workFlow.select"] ?? "select stage"}>
              {stageWorkFlowOption.map(item => (
                  <Option value={item.code} key={item.code}>{ languageMap?.[`project.management.workFlow.${item.enName.toLowerCase().replace(/ /g, "_")}`] ?? "item.enName" }</Option>
              ))}
            </Select>
          </Form.Item>
      )
    },
    {
      title: languageMap?.["project.management.workFlow.name"] ?? 'Name',
      dataIndex: 'name',
      render: (_, record) => {
        const lang = user.language || 'en';
        const fieldMap = {
          kr: 'krName',
          en: 'enName',
          vn: 'vnName',
        };
        const fieldName = fieldMap[lang] ?? 'enName';

        return (
            <>
              <Form.Item
                  name={['progressRequests', record.key, fieldName]}
                  initialValue={record[fieldName]}
                  rules={[
                    {
                      required: true,
                      message:
                          languageMap?.["project.management.require.nameWorkflow"] ??
                          "Require name",
                    },
                    {
                      max: 100,
                      message: 'Name cannot exceed 100 characters!',
                    },
                  ]}
                  className="p-0 m-0"
              >
                <Input
                    disabled={
                      different.type === "UPDATED" &&
                      !permissionCurrentUser?.includes("U")
                    }
                    onClick={() => handleInputClick(record.key)}
                    maxLength={100}
                    placeholder={
                      languageMap?.["project.management.workFlow.plahe"] ??
                      "work flow name"
                    }
                />
              </Form.Item>

              {["krName", "enName", "vnName"]
                  .filter((key) => key !== fieldName)
                  .map((name) => (
                      <Form.Item
                          key={name}
                          name={['progressRequests', record.key, name]}
                          initialValue={record[name]}
                          rules={[
                            {
                              required: true,
                              message:
                                  languageMap?.["project.management.require.nameWorkflow"] ??
                                  "Require name",
                            },
                            {
                              max: 100,
                              message: 'Name cannot exceed 100 characters!',
                            },
                          ]}
                          noStyle
                          hidden
                      >
                        <Input maxLength={100} />
                      </Form.Item>
                  ))}
            </>
        );
      }
    },
    {
      title: languageMap?.["project.management.workFlow.color"] ?? 'Color',
      dataIndex: 'color',
      width: 100,
      render: (_, record) => (
        <Form.Item name={['progressRequests', record.key, 'color']} initialValue="#1677ff"
                   getValueFromEvent={(e) => e?.toHexString()} noStyle>
          <ColorPicker disabled={different.type === "UPDATED" && !permissionCurrentUser?.includes("U")} size="small"/>
        </Form.Item>
      )
    },

    {
      title: '',
      dataIndex: 'action',
      width: 70,
      render: (_, record) => (
        <Button onClick={() => handleDelete(record.key)} type="text" disabled={!record.newData}>
          <DeleteOutlined className="text-[red]"/>
        </Button>
      ),
    }
  ];

  const handleAdd = () => {
    const dataWorkFlow = [
      {
        key: count,
        segmentCode: null,
        krName: null,
        enName: null,
        vnName: null,
        color: null,
        sortSequence: null,
        newData: true,
      }
    ]

    const updatedWorkFlow = [...workFlow, ...dataWorkFlow].map((item, index) => {
      return {
        ...item,
        sortSequence: index + 1,
      }
    })

    setWorkFlow(updatedWorkFlow);
    setCount(count + 1);
  }

  const handleDelete = (key) => {
    const newWorkFlow = workFlow.filter((item) => item.key !== key);
    const updatedWorkFlow = newWorkFlow.map((item, index) => {
      return {
        ...item,
        sortSequence: index + 1,
      }
    })

    setWorkFlow(updatedWorkFlow);
  };

  const handleInputClick = (key) => {
    setIsWorkFlowIME(true);
    setEditingKey(key);
  };

  const handleModalCancel = () => {
    setIsWorkFlowIME(false);
    setEditingKey(null);
  };

  const handleWorkFlowChange = (newWorkFlow) => {
    const updatedWorkFlow = newWorkFlow.map((item, index) => {
      return {
        ...item,
        sortSequence: index + 1,
      }
    })

    setWorkFlow(updatedWorkFlow);
    workFlow.forEach(item => {
      const findElement = updatedWorkFlow.find(element => element.key === item.key);
      form.setFields([
        {
          name: ['progressRequests', findElement.key, 'sortSequence'],
          value: findElement?.sortSequence,
        }
      ]);
    });
  };

  const updateWorkFlowItem = (updatedValues) => {
    const updatedWorkFlow = workFlow.map(item => {
      if (item.key === editingKey) {
        return {
          ...item,
          krName: updatedValues.krName,
          enName: updatedValues.enName,
          vnName: updatedValues.vnName,
        };
      }
      return item;
    });
    setWorkFlow(updatedWorkFlow);
  };

  useEffect(() => {
    if (initialValues.type === "UPDATED") {
      const currentWorkFlow = initialValues.progressRequests.sort((a, b) => a.sortSequence - b.sortSequence);
      setWorkFlow(currentWorkFlow.map((item, index) => {
        return {
          ...item,
          key: index,
        }
      }))
      setCount(initialValues.progressRequests.length);
    }
  }, [initialValues]);

  return (
    <div className={`${!isMobile ? "pt-4" : ""}`}>
      <div>
        <div className="flex justify-between items-center pb-4">
          <span className="font-bold">{languageMap?.["project.management.workFlow"] ?? "Work Flow" }</span>
          <Button disabled={different.type === "UPDATED" && !permissionCurrentUser?.includes("U")} type="primary" onClick={handleAdd}>{languageMap?.["project.management.item.addWorkFlow"] ?? "Add item workflow +" } </Button>
        </div>


        {isMobile ? (
            <MobileWorkflowView
                workFlow={workFlow}
                handleWorkFlowChange={handleWorkFlowChange}
                languageMap={languageMap}
                different={different}
                permissionCurrentUser={permissionCurrentUser}
                stageWorkFlowOption={stageWorkFlowOption}
                handleInputClick={handleInputClick}
                handleDelete={handleDelete}
            />
        ) : (
            <DndTable initialData={workFlow} columns={columns} onUpdate={handleWorkFlowChange}/>
        )}

      </div>

      {isWorkFlowIME && (
        <ModalWorKFlowIME
          isWorkFlowIME={isWorkFlowIME}
          editingKey={editingKey}
          handleModalCancel={handleModalCancel}
          updateWorkFlowItem={updateWorkFlowItem}
        />
      )}
    </div>
  );
};

export {WorkFlow};